import React, { useContext, useEffect, useState } from 'react';

import { CommentOutlined, LockOutlined, PauseOutlined, SendOutlined, PlayCircleOutlined, DeleteOutlined, FormOutlined } from '@ant-design/icons';
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';
import { Button, Modal, Popconfirm, Select, Switch } from 'antd';
import SL_Button from '../../components/buttons/Button';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api';
import monitory_room_grid_columns from './grid_columns/monitory_room_grid_columns';
import { Option } from 'antd/lib/mentions';
import { CommentaryModal } from '../../components/modals/CommentaryModal'
import { displayMessage } from '../../services/helper';
import AddPatient from './AddPatient';

var last_row_id = null
var last_action = null
var last_field = null


export default function CreateControl(props) {
    const {setShowLoading, windowHeight, mobile_mode, user, setUser, enums, setEnums, interruptions, setInterruptions} = useContext(GeneralContext)

    const [currentControl, setCurrentControl] = useState(null)

    const [currentMonitors, setCurrentMonitors] = useState([])

    const [columns, setColumns] = useState(monitory_room_grid_columns)
    const [change_controls, setChangeControls] = useState(null)

    const [reloadGrid, setReloadGrid] = useState(false)
    const [isModalAddPatientVisible, setIsModalAddPatientVisible] = useState(false)
    const [isModalChangeMonitorVisible, setIsModalChangeMonitorVisible] = useState(false)
    const [isModalCommentaryVisible, setIsModalCommentaryVisible] = useState(false)

    const [haveMultipleSelect, setHaveMultipleSelect] = useState(false)
    const [haveSomethingSelected, setHaveSomethingSelected] = useState(false)

    const [areAllRowsSameStatus, setAreAllRowsSameStatus] = useState(false)
    const [allSelectedRowsRunning, setAllSelectedRowsRunning] = useState(false)

    const [controls, setControls] = useState([])


    useEffect(
        () => {
            if (!enums) {
                setShowLoading(true)
                api.auth.getEnums().then(
                    rs => setEnums(rs.data)
                )
                return
            }

            setColumns(
                monitory_room_grid_columns.concat(
                    [
                        actionAddRemove({ ...enums?.EEventTypes?.OPEN_LIP }),
                        actionAddRemove({ ...enums?.EEventTypes?.CAMERA_OFF }),
                        actionFinish,
                        actionPauseResume,
                        actionChange,
                        actionToWaiting,
                        actionComment,
                        actionCancel,
                    ]
                )
            )

            loadControlsData()
            loadCurrentMonitorsData()
            startInterruptions()
            setShowLoading(false)

            return () => {
                // Anything in here is fired on component unmount.
                stopInterruptions()
            }
        }, [enums]
    )

    useEffect(() => {
        gridRef.current.setSelectionModel([])
    }, [haveMultipleSelect])

    useEffect(() => {
        loadCurrentMonitorsData()
    }, [controls])

    const loadControlsData = async () => {
        try {
            setShowLoading(true)

            const rs = await api.dialy_controls.listCurrents({ inMonitory: true })

            gridRef.current.setSelectionModel([])
            setControls(rs.data)
        }
        finally {
            setShowLoading(false)
        }
    }

    const loadCurrentMonitorsData = () => {
        api.monitor.getCurrent().then(
            rs => setCurrentMonitors(rs.data)
        )
    }

    const startInterruptions = () => {
        interruptions.push(setInterval(() => {
            loadControlsData()
        }, 30000))
        setInterruptions(interruptions)
    }

    const stopInterruptions = () => {
        interruptions.forEach(i => clearInterval(i))
    }

    const DataGridProHeight = windowHeight * 0.7

    const gridRef = useGridApiRef()

    const handleOnOpenModalAddPatient = () => {
        setIsModalAddPatientVisible(true)
    }

    const handleOnCloseModalAddPatient = () => {
        setIsModalAddPatientVisible(false)
    }

    const handleOnCloseModalChangeMonitor = () => {
        setIsModalChangeMonitorVisible(false)
        startInterruptions()
    }

    const handleRowChange = e => {
        setCurrentControl(e?.row)
    }

    const incrementControls = (control, field, value) => {
        if (controls?.length) {
            setControls(controls.map(
                c => {
                    if (c.id == control.id) {
                        c[field] = c[field] + value
                    }
                    if (c[field]) {

                    }
                    return c
                }
            ))
        }
    }

    const setControlFieldValue = (control, field, value) => {
        if (controls?.length) {
            setControls(controls.map(
                c => {
                    if (c.id == control.id) {
                        c[field] = value
                    }
                    return c
                }
            ))
        }
    }

    const handleOnClickChangeMonitorControl = controls => {

        setChangeControls(controls)
        setIsModalChangeMonitorVisible(true)
        stopInterruptions()
    }

    const handleOnClickFinishControl = async (controls) => {
        setShowLoading(true)
        try {
            let payload = formatControlsToArrayIds(controls)
            await api.dialy_controls.end(payload)
            .then(
                rs => loadControlsData()
            )

        } catch (error) {
            let updatedUser = await api.user.get(user?.id)
            setUser(updatedUser.data)
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    const handleOnClickPauseResumeControl = async (controls) => {
        setShowLoading(true)
        try {
            let controlsObj = formatControlsToArrayIds(controls)
            if (controls[0].paused_at != null) {
                await api.dialy_controls.resume(controlsObj)
                    .then(
                        async rs => {
                            await loadControlsData();
                            alert(displayMessage('CONTROL_RESUMED_SUCCESS'), 'success', '')
                        }
                    )
                let updatedUser = await api.user.get(user?.id)
                setUser(updatedUser.data)
            }
            else {
                await api.dialy_controls.pause(controlsObj)
                    .then(
                        async rs => {
                            await loadControlsData();
                            alert(displayMessage('CONTROL_PAUSED_SUCCESS'), 'success', '')
                        },
                        async err => {
                            let updatedUser = await api.user.get(user?.id)
                            setUser(updatedUser.data)
                        }
                    )
            }
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    const handleOnClickPauseControl = async (controls) => {
        setShowLoading(true)

        try {
            let controlsObj = formatControlsToArrayIds(controls)
            await api.dialy_controls.pause(controlsObj)
                .then(
                    async rs => {
                        await loadControlsData();
                        alert(displayMessage('CONTROL_PAUSED_SUCCESS'), 'success', '')
                    },
                    async err => {
                        let updatedUser = await api.user.get(user?.id)
                        setUser(updatedUser.data)
                    }

                )
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    const handleOnClickResumeControl = async (controls) => {
        setShowLoading(true)

        try {
            let controlsObj = formatControlsToArrayIds(controls)
            await api.dialy_controls.resume(controlsObj)
                .then(
                    async rs => {
                        await loadControlsData();
                        alert(displayMessage('CONTROL_RESUMED_SUCCESS'), 'success', '')
                    }
                )
        } catch (error) {
            let updatedUser = await api.user.get(user?.id)
            setUser(updatedUser.data)
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    const handleOnClickMore = (control, field, code) => {
        setShowLoading(true)
        incrementControls(control, field, 1)

        let payload = { ...control, event_type: code, is_in_exercise_room: false }

        api.dialy_controls.addEvent(payload).then(
            rs => {
                setControlFieldValue(rs?.data[field])
                loadControlsData()
            },
            async err => {
                loadControlsData()
                let updatedUser = await api.user.get(user?.id)
                setUser(updatedUser.data)
            }
        )

        last_row_id = control.id
        last_field = field
        last_action = "more"

    }

    const handleOnClickLess = (control, field, code) => {
        if (control[field]) {
            setShowLoading(true)

            let payload = { ...control, event_type: code, is_in_exercise_room: false }

            api.dialy_controls.removeEvent(payload).then(
                rs => {
                    loadControlsData()
                    setControlFieldValue(rs?.data[field])
                },
                async err => {
                    loadControlsData()
                    let updatedUser = await api.user.get(user?.id)
                    setUser(updatedUser.data)
                }
            )

            last_row_id = control.id
            last_field = field
            last_action = "less"
        }
        else {
            alert(displayMessage('AVALIATION_WARNING'), 'error')
        }

    }

    const handleOpenCommentaryModal = (row) => {
        setCurrentControl(row)
        setIsModalCommentaryVisible(true)
    }

    const handleCloseCommentModal = () => {
        setIsModalCommentaryVisible(false)
    }

    const reloadDataGrid = () => {
        setReloadGrid(!reloadGrid)
    }

    const handleAddPatient = async (patient, monitor_id = null, in_exercise = false) => {

        if (user.monitor_status == enums?.EMonitorStatus?.UNAVAILABLE?.code) {
            return alert(displayMessage('INDISPONIBLE_ARNING'))
        }

        const dialy_control = {
            "patient_id": patient?.id,
            "open_lip": 0,
            "camera_off": 0,
            "chewing": 0,
            "ended_at": 0,
            "exercise_done": 0,
            "camera_position": 0,
            "correct_execution": 0,
            "concentration_activity": 0,
        }
        try {
            setShowLoading(true)
            if (in_exercise) {
                await api.dialy_controls.createInExercise(dialy_control, monitor_id)
            }
            else {
                await api.dialy_controls.create(dialy_control)
            }
            loadControlsData()

        } catch (error) {
            let updatedUser = await api.user.get(user?.id)
            setUser(updatedUser.data)

        } finally {
            handleOnCloseModalAddPatient()
            reloadDataGrid()
            setShowLoading(false)
        }
    }

    const handleOnChangeMultipleSelect = checked => {
        if (checked) {
            stopInterruptions()
        } else {
            startInterruptions()
        }
        setHaveMultipleSelect(checked)
    }

    const handleOnCancel = async (controls) => {
        try {
            setShowLoading(true);
            let controlsObj = formatControlsToArrayIds(controls)

            const id = user.id
            await api.dialy_controls.cancel(id, controlsObj)
            loadControlsData()
            alert(displayMessage('CANCEL_MONITORY_SUCCESS'))
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false);
        }
    }

    const chooseBackgroundColor = (row_id, field) => {
        if (row_id == last_row_id && field == last_field) {

            if (last_action == "less") {
                return "#ffdddd"
            } else {
                return "#cfffdc"
            }
        }

        return null
    }

    const formatControlsToArrayIds = (controls) => {
        let payload = controls.map((control) => {
            return { id: control?.id }
        })
        return payload
    }

    const actionAddRemove = item => {
        return {
            field: item.field,
            headerName: item.description,
            width: user.user_type == enums.EUserTypes.MONITOR.code ? 150 : 100,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            style: { display: 'flex' },
            renderCell: (params) => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            padding: 5,
                            width: '100%',
                            height: '100%',
                            alignItems: 'center',
                            justifyContent: user.user_type == enums.EUserTypes.MONITOR.code ? 'space-between' : 'center',
                            background: chooseBackgroundColor(params.row.id, item.field),
                        }} >
                        {
                            user.user_type == enums.EUserTypes.MONITOR.code &&
                            <div>
                                <SL_Button
                                    style={{ background: '#ffdddd', borderColor: 'red', color: 'red', fontWeight: 'bold' }}
                                    className='items-center w-30 flex'
                                    onClick={() => handleOnClickLess(params.row, item.field, item.code)}
                                    shape="circle"
                                    disabled={params.row.paused_at != null}
                                    title={params.row.paused_at != null ? displayMessage('ACTION_DISABLED_CONTROL_PAUSED') : ''}
                                >
                                    -
                                </SL_Button>

                            </div>
                        }
                        <div style={{ fontWeight: 'bold', borderRadius: '5px', background: '#1b3663', color: 'white', height: 30, width: 30, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            {params.value}
                        </div>
                        {
                            user.user_type == enums.EUserTypes.MONITOR.code &&
                            <div>
                                <SL_Button
                                    style={{ background: '#cfffdc', borderColor: 'green', color: 'green', fontWeight: 'bold' }}
                                    className='items-center w-30 flex'
                                    shape="circle"
                                    onClick={() => handleOnClickMore(params.row, item.field, item.code)}
                                    disabled={params.row.paused_at != null}
                                    title={params.row.paused_at != null ? displayMessage('ACTION_DISABLED_CONTROL_PAUSED') : ''}
                                >
                                    +
                                </SL_Button>
                            </div>
                        }
                    </div>
                )
            },
            disableColumnSelector: true
        }
    }

    const actionFinish = {
        field: 'finish_action',
        headerName: displayMessage('END_02'),
        width: 100,
        sortable: false,
        align: 'center',
        renderCell: (params) => {
            return (
                <div>
                    <Popconfirm
                        zIndex={10001}
                        placement="bottomLeft"
                        title={displayMessage('COMFIRMATION_END_MONITORY')}
                        onConfirm={() => handleOnClickFinishControl([params.row])}
                        okText={displayMessage('YES')}
                        cancelText={displayMessage('NO')}
                        disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code}
                    >
                        <SL_Button
                            style={{ background: 'red', borderColor: 'pink', color: 'pink', fontWeight: 'bold' }}
                            shape="circle"
                            icon={<LockOutlined />}
                            title={params.row.paused_at != null ? displayMessage('ACTION_DISABLED_CONTROL_PAUSED') : ''}
                            disabled={params.row.paused_at != null || user?.user_type != enums?.EUserTypes?.MONITOR?.code}
                        >
                        </SL_Button>
                    </Popconfirm>

                </div>
            )
        },
        disableColumnSelector: true
    }

    const actionChange = {
        field: 'change_action',
        headerName: displayMessage('TRANSFER'),
        width: 100,
        sortable: false,
        align: 'center',
        renderCell: (params) => {
            return (
                <div>
                    <SL_Button
                        style={{ background: 'blue', borderColor: 'lightblue', color: 'lightblue', fontWeight: 'bold' }}
                        shape="circle"
                        onClick={() => handleOnClickChangeMonitorControl([params.row])}
                        icon={<SendOutlined />}
                        title={params.row.paused_at != null ? displayMessage('ACTION_DISABLED_CONTROL_PAUSED') : ''}
                        disabled={params.row.paused_at != null || user?.user_type != enums?.EUserTypes?.MONITOR?.code}
                    >
                    </SL_Button>

                </div>
            )
        },
        disableColumnSelector: true
    }

    const actionPauseResume = {
        field: 'pause_resume_action',
        headerName: displayMessage('PAUSE_RESUME'),
        width: 150,
        sortable: false,
        align: 'center',
        renderCell: (params) => {
            if (params.row.paused_at == null) {
                return (
                    <Popconfirm
                        zIndex={10001}
                        placement="bottomLeft"
                        title={displayMessage('COMFIRMATION_PAUSE_MONITORY')}
                        onConfirm={() => handleOnClickPauseControl([params.row])}
                        okText={displayMessage('YES')}
                        cancelText={displayMessage('NO')}
                        disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code}
                    >
                        <SL_Button
                            style={{ background: 'gray', borderColor: 'lightgray', color: 'lightgray', fontWeight: 'normal' }}
                            shape="circle"
                            icon={<PauseOutlined />}
                        >
                        </SL_Button>
                    </Popconfirm>
                )
            }

            return (
                <Popconfirm
                    zIndex={10001}
                    placement="bottomLeft"
                    title={displayMessage('COMFIRMATION_RESUME_MONITORY')}
                    onConfirm={() => handleOnClickResumeControl([params.row])}
                    okText={displayMessage('YES')}
                    cancelText={displayMessage('NO')}
                    disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code}
                >
                    <SL_Button
                        style={{ background: '#6239bd', borderColor: 'pink', color: 'pink', fontWeight: 'bold' }}
                        shape="circle"
                        icon={<PlayCircleOutlined style={{ marginLeft: -1 }} />}
                        disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code}
                    >

                    </SL_Button>
                </Popconfirm>
            )
        },
        disableColumnSelector: true
    }

    const actionCancel = {
        field: 'cancel_action',
        headerName: displayMessage('CANCEL'),
        width: 100,
        sortable: false,
        align: 'center',
        renderCell: (params) => {
            return (
                <div>
                    <Popconfirm
                        zIndex={10001}
                        placement="bottomLeft"
                        title={displayMessage('COMFIRMATION_CANCEL_MONITORY', [`${params.row?.Patient?.first_name} ${params.row?.Patient?.last_name}`])}
                        onConfirm={() => handleOnCancel([params.row])}
                        okText={displayMessage('YES')}
                        cancelText={displayMessage('NO')}
                        disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || params?.row?.paused_at != null}
                    >
                        <SL_Button
                            style={{ background: 'red', borderColor: 'pink', color: 'pink', fontWeight: 'bold' }}
                            shape="circle"
                            icon={<DeleteOutlined />}
                            disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || params?.row?.paused_at != null}
                        >
                        </SL_Button>
                    </Popconfirm>

                </div>
            )
        },
        disableColumnSelector: true
    }

    const actionToWaiting = {
        field: 'to_waiting_action',
        headerName: displayMessage('SEND_TO_EXERCISE_ROOM'),
        width: 180,
        sortable: false,
        align: 'center',
        renderCell: (params) => {
            return (
                <div>
                    <Popconfirm
                        zIndex={10001}
                        placement="bottomRight"
                        title={displayMessage('COMFIRMATION_SEND_TO_EXERCISE_ROOM')}
                        onConfirm={() => handleSendToExerciseRoom([params.row])}
                        okText={displayMessage('YES')}
                        cancelText={displayMessage('NO')}
                        disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || params.row.paused_at != null}
                    >
                        <SL_Button
                            style={{ background: 'green', borderColor: 'lightgreen', color: 'lightgreen', fontWeight: 'bold' }}
                            shape="circle"
                            icon={<FormOutlined />}
                            disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || params.row.paused_at != null}
                        >
                        </SL_Button>
                    </Popconfirm>
                </div>
            )
        },
        disableColumnSelector: true
    }

    const actionComment = {
        field: 'commentary',
        headerName: displayMessage('COMMENT'),
        width: 100,
        sortable: false,
        align: 'center',
        renderCell: (params) => {
            return (
                <div>
                    <SL_Button
                        style={{ background: 'orange', borderColor: 'lightyellow', color: 'lightyellow', fontWeight: 'bold' }}
                        shape="circle"
                        onClick={() => handleOpenCommentaryModal(params.row)}
                        icon={<CommentOutlined />}
                        disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code}
                    >
                    </SL_Button>
                </div>
            )
        },
    }

    const handleChangeMonitor = async (monitor) => {
        if (user.monitor_status == enums?.EMonitorStatus?.UNAVAILABLE?.code) {
            return alert(displayMessage('INDISPONIBLE_ARNING'))
        }
        try {
            let controlsObj = formatControlsToArrayIds(change_controls)

            let payload = { new_monitor_id: monitor.id, controlsObj }
            await api.dialy_controls.exchangeMonitor(user.id, payload)
            setIsModalChangeMonitorVisible(false)
            loadControlsData()
        } catch (error) {
            handleOnCloseModalChangeMonitor()
            let updatedUser = await api.user.get(user?.id)
            setUser(updatedUser.data)
        }
    }

    const ChangeMonitor = props => {
        const [monitors, setMonitors] = useState([])
        const [monitor_change, setMonitorChange] = useState(null)
        useEffect(() => {
            loadMonitors()
        }, [])

        const loadMonitors = async () => {
            if (monitors.length <= 0) {
                await api.monitor.list()
                    .then(
                        rs => {
                            let tempMonitors = []
                            for (let index = 0; index < rs.data.length; index++) {
                                const element = rs.data[index];
                                if (element.id != user.id) {
                                    tempMonitors.push(element)
                                }
                            }
                            setMonitors(tempMonitors)
                        }
                    )
            }
        }

        return (
            <Modal
                title={<div className="text-xl font-bold text-appian-blue">
                    {displayMessage('CHANGE_MONITOR_TITLE')}
                </div>}
                visible={props.isModalVisible}
                onCancel={props.handleOnCloseModal}
                centered={true}
                footer={[]}
                width={mobile_mode ? '90%' : 500}
                style={{ position: 'relative' }}
                bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: 'auto' }}
            >
                <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5, flex: 1 }}>
                        <div style={{ fontWeight: 'bold', color: '#1b3663' }}> {displayMessage('MONITOR')}:</div>
                        <Select
                            style={{ width: mobile_mode ? '100%' : 250 }}
                            size="middle"
                            placeholder={displayMessage('MONITOR')}
                            onChange={value => setMonitorChange(monitors.find(m => m.id == value))}
                            allowClear={true}
                        >
                            {monitors?.map((monitor, idx) => <Option key={monitor.id} value={monitor.id}>{monitor.full_name}</Option>)}
                        </Select>
                    </div>
                    <Button
                        onClick={() => props.handleChangeMonitor(monitor_change)}
                        type="primary"
                        style={{ marginTop: 22, width: mobile_mode ? '100%' : 100, fontWeight: 'bold' }}
                    >
                        Trocar
                    </Button>
                </div>

            </Modal>
        )
    }

    const handleWhatIsSelectedInGrid = () => {
        const _controls = []
        gridRef.current.getSelectedRows().forEach((e) => _controls.push(e))
        if (_controls.length > 0) {
            setHaveSomethingSelected(true)
            if (_controls.length > 1) {
                let allPausedAtNull = true;
                let allPausedAtNotNull = true;

                for (let i = 0; i < _controls.length; i++) {
                    if (_controls[i].paused_at !== null) {
                        allPausedAtNull = false;
                    } else {
                        allPausedAtNotNull = false;
                    }
                }

                if (allPausedAtNull == allPausedAtNotNull) {
                    setAreAllRowsSameStatus(false)
                    setAllSelectedRowsRunning(false)
                }
                else {
                    setAreAllRowsSameStatus(true)
                    _controls[0].paused_at == null && setAllSelectedRowsRunning(true)
                }
            }
            else {
                setAreAllRowsSameStatus(true)
                _controls[0].paused_at == null && setAllSelectedRowsRunning(true)
            }
        }
        else {
            setHaveSomethingSelected(false)
            setAllSelectedRowsRunning(false)
        }
    }

    const handleSendToExerciseRoom = async (controls) => {
        setShowLoading(true);
        try {
            let payload = formatControlsToArrayIds(controls)

            await api.dialy_controls.sendToWaitingRoom(user.id, payload)
        } catch (error) {
            let updatedUser = await api.user.get(user?.id)
            setUser(updatedUser.data)
            console.log(error)
        } finally {
            loadControlsData()
            setShowLoading(false);
        }
    }


    return (
        <div>

            {
                isModalAddPatientVisible
                &&
                <AddPatient
                    isModalVisible={isModalAddPatientVisible}
                    handleOnCloseModal={handleOnCloseModalAddPatient}
                    refreshControls={loadControlsData}
                    handleAddPatient={handleAddPatient}
                />
            }

            {
                isModalChangeMonitorVisible
                &&
                <ChangeMonitor
                    isModalVisible={isModalChangeMonitorVisible}
                    handleOnCloseModal={handleOnCloseModalChangeMonitor}
                    refreshControls={loadControlsData}
                    handleChangeMonitor={handleChangeMonitor}
                />
            }

            {
                isModalCommentaryVisible
                &&
                <CommentaryModal
                    isModalVisible={isModalCommentaryVisible}
                    handleOnCloseModal={handleCloseCommentModal}
                    currentControl={currentControl}
                />

            }

            <div className={`flex flex-1 justify-between flex-col gap-5`} >

                <div className={`flex flex-1  flex-row gap-5`}>
                    {
                        currentMonitors.map(
                            cm =>
                                <div
                                    style={{
                                        minWidth: 150,
                                        height: 70,
                                        border: '1px solid lightgray',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                        WebkitBoxShadow: "7px 4px 16px -10px rgba(0,0,0,0.75)",
                                        MozBoxShadow: "7px 4px 16px -10px rgba(0,0,0,0.75)",
                                        boxShadow: "7px 4px 16px -10px rgba(0,0,0,0.75)",
                                        paddingLeft: '8px',
                                        paddingRight: '8px'
                                    }}>
                                    <div style={{ fontWeight: 'bold', color: '#1b3663', overflow: 'hidden' }}>{cm.first_name} {cm.last_name}</div>
                                    <div><strong>{displayMessage('PATIENTS')}:</strong> {cm?.DialyControls?.length}</div>
                                </div>
                        )
                    }
                </div>

                <div className={`flex flex-1 ${mobile_mode ? 'flex-col justify-center items-center' : 'flex-col'} justify-between gap-2`}>

                    <div style={{ display: 'flex', flex: 1, justifyContent: 'space-between', flexDirection: mobile_mode ? 'column' : 'row' }}>
                        <div className={`flex flex-1 ${mobile_mode ? 'flex-col justify-center items-center' : 'flex-row'}  gap-2`}>
                            <SL_Button
                                type='primary'
                                className={`items-center ${mobile_mode ? 'w-full' : 'w-30'} flex button-color`}
                                onClick={handleOnOpenModalAddPatient}
                                color={'#1b3663'}
                                background={'#1b3663'}
                                disabled={user.user_type != enums?.EUserTypes?.MONITOR?.code}
                            >
                                {displayMessage('ADD_PATIENT_PLUS_SIGN')}
                            </SL_Button>
                            <SL_Button
                                type='primary'
                                className={`items-center ${mobile_mode ? 'w-full' : 'w-30'} flex button-color`}
                                onClick={() => loadControlsData()}
                                color={'#1b3663'}
                                background={'#1b3663'}
                            >
                                Atualizar
                            </SL_Button>
                        </div>


                        <Switch
                            onChange={handleOnChangeMultipleSelect}
                            style={{ height: 30, width: mobile_mode ? '100%' : null, maxWidth: 180, marginTop: mobile_mode ? 10 : 0 }}
                            unCheckedChildren="Permitir seleção multipla"
                            checkedChildren="Bloquear seleção multipla"
                            disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code}
                        />

                    </div>
                    {
                        haveMultipleSelect &&
                        <div style={{ display: 'flex', flex: 1, flexDirection: 'row', columnGap: 15, marginTop: mobile_mode ? 5 : 0 }}>
                            <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', rowGap: mobile_mode ? 10 : '', columnGap: mobile_mode ? '' : 15 }}>
                                <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', rowGap: mobile_mode ? 10 : '', columnGap: mobile_mode ? '' : 15 }} >
                                    <Popconfirm
                                        zIndex={10001}
                                        placement="bottomLeft"
                                        title={displayMessage('COMFIRMATION_END_MONITORY')}
                                        onConfirm={() => {
                                            let _controls = []
                                            gridRef.current.getSelectedRows().forEach((e) => _controls.push(e))
                                            handleOnClickFinishControl(_controls)
                                        }
                                        }
                                        okText={displayMessage('YES')}
                                        cancelText={displayMessage('NO')}
                                        disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || haveSomethingSelected == false || allSelectedRowsRunning == false}
                                    >
                                        <SL_Button
                                            style={{ fontWeight: 'bold', maxWidth: mobile_mode ? 300 : '' }}
                                            danger={true}
                                            icon={<LockOutlined />}
                                            disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || haveSomethingSelected == false || allSelectedRowsRunning == false}
                                        >
                                            {displayMessage('END_02')}
                                        </SL_Button>
                                    </Popconfirm>

                                    <Popconfirm
                                        zIndex={10001}
                                        placement="bottomLeft"
                                        title={displayMessage(allSelectedRowsRunning ? 'COMFIRMATION_PAUSE_MONITORY' : 'COMFIRMATION_RESUME_MONITORY')}
                                        onConfirm={() => {
                                            const _controls = []
                                            gridRef.current.getSelectedRows().forEach((e) => _controls.push(e))
                                            handleOnClickPauseResumeControl(_controls)
                                        }}
                                        okText={displayMessage('YES')}
                                        cancelText={displayMessage('NO')}
                                        disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || haveSomethingSelected == false}
                                    >
                                        <SL_Button
                                            style={{ fontWeight: 'normal', maxWidth: mobile_mode ? 300 : '' }}
                                            icon={<PauseOutlined />}
                                            disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || haveSomethingSelected == false || areAllRowsSameStatus == false}
                                        >
                                            {displayMessage('PAUSE_RESUME')}
                                        </SL_Button>
                                    </Popconfirm>
                                </div>

                                <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column-reverse' : 'row', rowGap: mobile_mode ? 10 : '', columnGap: mobile_mode ? '' : 15 }} >
                                    <SL_Button
                                        style={{ maxWidth: mobile_mode ? 300 : '' }}
                                        onClick={() => {
                                            const _controls = []
                                            gridRef.current.getSelectedRows().forEach((e) => _controls.push(e))
                                            handleOnClickChangeMonitorControl(_controls)
                                        }}
                                        icon={<SendOutlined />}
                                        disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || haveSomethingSelected == false || allSelectedRowsRunning == false}
                                    >
                                        {displayMessage('MONITOR_CHANGE')}
                                    </SL_Button>
                                    <Popconfirm
                                        zIndex={10001}
                                        placement="bottomLeft"
                                        title={displayMessage('COMFIRMATION_SEND_TO_EXERCISE_ROOM')}
                                        onConfirm={() => {
                                            const _controls = []
                                            gridRef.current.getSelectedRows().forEach((e) => _controls.push(e))
                                            handleSendToExerciseRoom(_controls)
                                        }}
                                        okText={displayMessage('YES')}
                                        cancelText={displayMessage('NO')}
                                        disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || haveSomethingSelected == false || areAllRowsSameStatus == false || allSelectedRowsRunning == false}
                                    >
                                        <SL_Button
                                            style={{ fontWeight: 'normal', maxWidth: mobile_mode ? 300 : '' }}
                                            icon={<FormOutlined />}
                                            disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || haveSomethingSelected == false || areAllRowsSameStatus == false || allSelectedRowsRunning == false}
                                        >
                                            {displayMessage('SEND_TO_EXERCISE_ROOM')}
                                        </SL_Button>
                                    </Popconfirm>

                                </div>

                                <Popconfirm
                                    zIndex={10001}
                                    placement="bottomLeft"
                                    title={displayMessage('COMFIRMATION_CANCEL_MONITORY_2')}
                                    onConfirm={() => {
                                        const _controls = []
                                        gridRef.current.getSelectedRows().forEach((e) => _controls.push(e))
                                        handleOnCancel(_controls)
                                    }}
                                    okText={displayMessage('YES')}
                                    cancelText={displayMessage('NO')}
                                    disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || haveSomethingSelected == false || areAllRowsSameStatus == false || allSelectedRowsRunning == false}
                                >
                                    <SL_Button
                                        style={{ fontWeight: 'bold', maxWidth: mobile_mode ? 300 : '' }}
                                        danger={true}
                                        icon={<DeleteOutlined />}
                                        disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || haveSomethingSelected == false || areAllRowsSameStatus == false || allSelectedRowsRunning == false}
                                    >
                                        {displayMessage('CANCEL')}
                                    </SL_Button>
                                </Popconfirm>

                            </div>
                        </div>
                    }
                </div>

                <div style={{
                    height: DataGridProHeight,
                    minHeight: 300,
                    WebkitBoxShadow: "7px 4px 16px -10px rgba(0,0,0,0.75)",
                    MozBoxShadow: "7px 4px 16px -10px rgba(0,0,0,0.75)",
                    boxShadow: "7px 4px 16px -10px rgba(0,0,0,0.75)"
                }} >
                    <DataGridPro
                        rows={controls}
                        apiRef={gridRef}
                        style={{ height: '70vh' }}
                        density={"comfortable"}
                        columns={columns}
                        pagination
                        pageSize={100}
                        onRowClick={handleRowChange}
                        disableMultipleSelection
                        checkboxSelection={haveMultipleSelect}
                        onSelectionModelChange={() => handleWhatIsSelectedInGrid()}
                        disableSelectionOnClick={!haveMultipleSelect}
                    />
                </div>
            </div>
        </div>
    )
}